'use strict';

var React = require('react');

var Forms = require('../forms');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./upsell.scss');
}

var Upsell = (props) => {
    return (
        <div className='sp-global-upsell'>
            <div className='block'>
                <h1 dangerouslySetInnerHTML={{__html: props.text[props.sitetext + '.upsell.left.title'] }} />
                <div className='block-text' dangerouslySetInnerHTML={{__html: props.text[props.sitetext + '.upsell.left.body'] }} />
                <div className='block-button'>
                    <Forms.Button link='/budget-your-office' external={true} label={props.text[props.sitetext + '.upsell.left.button']} theme='dark' />
                </div>
            </div>
            <div className='block'>
                <h1 dangerouslySetInnerHTML={{__html: props.text[props.sitetext + '.upsell.right.title'] }} />
                <div className='block-text' dangerouslySetInnerHTML={{__html: props.text[props.sitetext + '.upsell.right.body'] }} />
                <div className='block-button'>
                    <Forms.Button link='/modern-office-design' external={true} label={props.text[props.sitetext + '.upsell.right.button']} theme='dark' />
                </div>
            </div>
        </div>
    );
}

module.exports = Upsell;



// WEBPACK FOOTER //
// ./src/components/upsell.jsx